
document.addEventListener('click', (e) => {
    const el = e.target.closest('.js-scroll-to');
    if (!el) {
        return;
    }

    const target = el.getAttribute('data-target');
    if (!target) {
        return;
    }

    const targetEl = document.querySelector(`.${target}`);
    if (targetEl) {
        const style = getComputedStyle(targetEl);
        const marginTop = parseInt(style.marginTop, 10);
        const paddingTop = parseInt(style.paddingTop, 10);
        const offsetTop = targetEl.offsetTop;
        const setScrollPosition = offsetTop - (marginTop + paddingTop)

        window.scrollTo({ top: setScrollPosition, behavior: 'smooth' });
    }

});